// File: cgp-confirmation-dialog.module.ts
// Author: Joseph M Diaz
// Date: 4/28/2017
// Desc: CGP Confirmation Dialog.
// Other Contributors:

import { NgModule } from '@angular/core';
import { MatLegacyDialogModule as MatDialogModule } from '@angular/material/legacy-dialog';
import { MatLegacyButtonModule as MatButtonModule } from '@angular/material/legacy-button';

import { CgpConfirmationDialogService } from './cgp-confirmation-dialog.service';
import { CgpConfirmationDialogComponent } from './cgp-confirmation-dialog.component';

@NgModule({
    imports: [
        MatDialogModule, MatButtonModule
    ],
    exports: [
        CgpConfirmationDialogComponent
    ],
    declarations: [
        CgpConfirmationDialogComponent
    ],
    providers: [
        CgpConfirmationDialogService
    ]
})
export class CgpConfirmationDialogModule { }
